import { useMutation, useQueryClient } from '@tanstack/react-query';
import { purchaseRequisitionService } from '@/services/purchaseRequisitionService';
import type { CancelPurchaseRequisitionRequest } from '@/services/purchaseRequisitionService';
import { useNotifications } from '@/stores/useNotificationStore';
import { getErrorMessage } from '@/utils/httpClient';
import { queryKeys } from '@/lib/queryKeys';

export const useCancelPurchaseRequisition = () => {
  const queryClient = useQueryClient();
  const notifications = useNotifications();

  return useMutation({
    mutationFn: (request: CancelPurchaseRequisitionRequest) =>
      purchaseRequisitionService.cancelPurchaseRequisition(request),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.orders.all });
      notifications.success(
        'Order Cancelled',
        `Order ${data.orderIdentifier} cancelled successfully`,
      );
    },
    onError: (error: unknown) => {
      const message = getErrorMessage(error);
      notifications.error('Order Cancel Failed', message);
    },
  });
};
